import { render, staticRenderFns } from "./BookingTemplateCreate.vue?vue&type=template&id=54fa188c"
import script from "./BookingTemplateCreate.vue?vue&type=script&lang=js"
export * from "./BookingTemplateCreate.vue?vue&type=script&lang=js"
import style0 from "./BookingTemplateCreate.vue?vue&type=style&index=0&id=54fa188c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports